import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  SCHEDULE_LOAD_TASK_DETAIL_BEGIN,
  SCHEDULE_LOAD_TASK_DETAIL_SUCCESS,
  SCHEDULE_LOAD_TASK_DETAIL_FAILURE,
  SCHEDULE_LOAD_TASK_DETAIL_DISMISS_ERROR,
} from './constants';

export function loadTaskDetail(args = {}) {
  return (dispatch) => {
    dispatch({
      type: SCHEDULE_LOAD_TASK_DETAIL_BEGIN,
    });
    const { projectId, version, taskId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/schedules/${taskId}`;
      const doRequest = axios.get(url, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: SCHEDULE_LOAD_TASK_DETAIL_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: SCHEDULE_LOAD_TASK_DETAIL_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadTaskDetailError() {
  return {
    type: SCHEDULE_LOAD_TASK_DETAIL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SCHEDULE_LOAD_TASK_DETAIL_BEGIN:
      return {
        ...state,
        loadTaskDetailPending: true,
        loadTaskDetailError: null,
      };

    case SCHEDULE_LOAD_TASK_DETAIL_SUCCESS:
      return {
        ...state,
        loadTaskDetailPending: false,
        loadTaskDetailError: null,
        taskDetail: action.data.schedule,
      };

    case SCHEDULE_LOAD_TASK_DETAIL_FAILURE:
      return {
        ...state,
        loadTaskDetailPending: false,
        loadTaskDetailError: action.data.error,
      };

    case SCHEDULE_LOAD_TASK_DETAIL_DISMISS_ERROR:
      return {
        ...state,
        loadTaskDetailError: null,
      };

    default:
      return state;
  }
}
